import HttpClient from '@/utility/http-client';
import * as firebase from 'firebase';
import { APP_CONFIG } from '@/config/app-config';
import axios, { ResponseType } from 'axios';

export default {
    exchangeRate() {
        return HttpClient.instance().get(`/api/exchange_rate/`);
    },
    configuration() {
        return HttpClient.instance().get(`/api/configuration/1`);
    },
    feeBuyPro() {
        return HttpClient.instance().get(`/api/feebuypro/`);
    },

    getCustomerLevels() {
        return HttpClient.instance().get(`/api/customer_levels/`);
    },

    getWarehouse() {
        return HttpClient.instance().get(`/api/stores/`);
    },

    getChinaStore() {
        return HttpClient.instance().get(`/api/chinaStores/`);
    },
    
    getFeeGuarantee() {
        return HttpClient.instance().get(`/api/feeguarantee/`);
    },

    getSafeLevel() {
        return HttpClient.instance().get(`/api/safe-level/`);
    },

    getSafeLevelByStore(id) {
        if(id) {
            return HttpClient.instance().get(`/api/safe-level-by-store/${id}`);
        }
        return false;
    },

    getDetailChinaStore(id) {
        return HttpClient.instance().get(`/api/chinaStores/${id}`);
    },

    getAvailableVouchers(order_id, order_type) {
        return HttpClient.instance().get(`/api/customer_vouchers/?order_id=${order_id}&order_type=${order_type}`);
    },

    getNotification(page: number, rowPerPage: number, filters: any[], bell: boolean) {
        const filter = filters && filters.length > 0 ? Buffer.from(JSON.stringify({ filter: filters })).toString('base64') : '';
        const url = `/api/notifications/?page=${page}&rowsPerPage=${rowPerPage}&filter=${filter}&bell=${bell}`;
        return HttpClient.instance().get(url);
    },

    updateStatusNotification(notifyId: number, dataRequest: any) {
        const url = `/api/notifications/${notifyId}`;
        return HttpClient.instance().post(url, dataRequest);
    },

    uploadFile(file, name) {
        const storageRef=firebase.storage().ref(`${APP_CONFIG.settings.firebase_prefix}/complain/${name}`).put(file);
        storageRef.on(`state_changed`, 
            () => {
                storageRef.snapshot.ref.getDownloadURL().then((url) => {
                    return url;
                });
            }
        );
    },

    deleteFile(name) {
        firebase.storage().ref(`${APP_CONFIG.settings.firebase_prefix}/complain/${name}`).delete().then(() => {
            // File deleted successfully
          }).catch((error) => {
            console.log(error)
            // Uh-oh, an error occurred!
          });
    },

    getProvince() {
        const httpClient = axios.create({
            baseURL: 'https://pos.pages.fm/api/v1'
        });
        return httpClient.get(`/geo/provinces`);
    },

    getDistrict(provinceId) {
        const httpClient = axios.create({
            baseURL: 'https://pos.pages.fm/api/v1'
        });
        return httpClient.get(`/geo/districts?province_id=${provinceId}`);
    },

    getCommune(districtID) {
        const httpClient = axios.create({
            baseURL: 'https://pos.pages.fm/api/v1'
        });
        return httpClient.get(`/geo/communes?district_id=${districtID}`);
    },
};
